import React, { useCallback } from "react";

export const ColumnHeader = ({ displayName, column, sorting, onSort }) => {
  const onSortAsync = useCallback(() => {
    if (column.userProvidedColDef.sortable !== false) {
      const sortField =
        column.userProvidedColDef.cellRendererParams?.sortField ||
        column.getColId();
      if (sortField === sorting.orderBy) {
        onSort(sortField, sorting.order === "asc" ? "desc" : "asc");
      } else {
        onSort(sortField, "desc");
      }
    }
  }, [column, sorting, onSort]);
  
  if(!column || !column.userProvidedColDef)
    return null;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div
        style={{
          paddingRight: 4,
          cursor:
            column.userProvidedColDef.sortable !== false ? "pointer" : "auto",
        }}
        onClick={onSortAsync}
      >
        {displayName}
      </div>
      {column.userProvidedColDef.sortable !== false &&
        (column.userProvidedColDef.cellRendererParams?.sortField ||
          column.getColId()) === sorting.orderBy && (
          <i
            className={`fa fa-long-arrow-alt-${
              sorting.order === "asc" ? "down" : "up"
            }`}
          />
        )}
    </div>
  );
};
